/**
  * @desc Umbraco Forms scripts
  * @author Jonas Havmøller - JHA
  * @requires jquery@1.11.3, umbraco forms
  * @note: Moved to seperate file to prevent inlining the scripts into razor-file. Rerember to add data-attr id and name to your umbraco form
*/

var novicell = novicell || {};

novicell.umbracoForms = novicell.umbracoForms || function () {
    var self = this;

    this.initForms = function() {

        $('.contour').each(function(){
            var $this = $(this);
            novicell.umbracoForms.init($this.data('id'), $this.data('name'), $this.data('msg'));
        })

    }

    this.init = function (formId, formName, msg) {


        var contourFieldValues,
            recordValues = $("#values_" + formId).length ? JSON.parse($("#values_" + formId).val()) : [],
            fsConditions = JSON.parse($("#fsConditions_" + formId).val()),
            fieldConditions = JSON.parse($("#fieldConditions_" + formId).val()),
            form = $("#contour_form_" + formName),
            $form = form.parents('div').first().find('form').first(); // Find the form. Sometimes it's a parent, sometimes it's a child. Therefore the weird code

            console.log($form.attr('action'));
            
            $(function () {
                $(".contour input, .contour  textarea, .contour select", form).change(function () {
                    PopulateFieldValues();
                    CheckRules();
                });

                ajaxSubmit($form, msg);

                PopulateFieldValues();
                CheckRules();
            });

            function PopulateFieldValues() {
                PopulateRecordValues();

                $(".contourPage select", form).each(function () {
                    contourFieldValues[$(this).attr("id")] = $("option[value='" + $(this).val() + "']", $(this)).text();
                });

                $(".contourPage textarea", form).each(function () {
                    contourFieldValues[$(this).attr("id")] = $(this).val();
                });

                $(".contourPage input", form).each(function () {

                    if ($(this).attr('type') == "text" || $(this).attr("type") == "hidden") {
                        contourFieldValues[$(this).attr("id")] = $(this).val();
                    }

                    if ($(this).attr('type') == "radio") {
                        if ($(this).is(':checked')) {
                            contourFieldValues[$(this).attr("name")] = $(this).val();
                        }
                    }

                    if ($(this).attr('type') == "checkbox") {

                        if ($(this).attr('id') != $(this).attr('name')) {
                            if ($(this).is(':checked')) {
                                if (contourFieldValues[$(this).attr("name")] == null) {
                                    contourFieldValues[$(this).attr("name")] = $(this).val();
                                }
                                else {
                                    contourFieldValues[$(this).attr("name")] += "," + $(this).val();
                                }
                            }
                        } else {

                            contourFieldValues[$(this).attr("name")] = $(this).is(':checked').toString();
                        }
                    }

                });
            }

            function PopulateRecordValues() {
                var fieldId;
                contourFieldValues = new Array();

                for (fieldId in recordValues) {
                    if ($("#" + fieldId).length === 0) {
                        contourFieldValues[fieldId] = recordValues[fieldId];
                    }
                }
            }

            function CheckRules() {
                umbracoForms.conditions.handle({
                    fsConditions: fsConditions,
                    fieldConditions: fieldConditions,
                    values: contourFieldValues
                });
            }
    }

    // public functions:
    return {
        init: init,
        initForms: initForms
    };
}();
